// extracted by mini-css-extract-plugin
module.exports = {"attach_button":"_103a151b99--attach_button--gPIMJ"};